/*
We're constantly improving the code you see. 
Please share your feedback here: https://form.asana.com/?k=uvp-HPgd3_hyoXRBw1IcNg&d=1152665201300829
*/

import PropTypes from "prop-types";
import React from "react";
import { BtnIconMore2 } from "../../icons/BtnIconMore2";
import "./style.css";

export const Subsection = ({
  withTootilp = false,
  withIcon = true,
  subsection = "subsection",
  withTextLink = false,
  subsectionClassName,
}) => {
  return (
    <div className="subsection">
      <div className="frame">
        <div className={`text-wrapper-2 ${subsectionClassName}`}>
          {subsection}
        </div>
      </div>

      <div className="frame-2">
        {withIcon && <BtnIconMore2 className="btn-icon-more" />}
      </div>
    </div>
  );
};

Subsection.propTypes = {
  withTootilp: PropTypes.bool,
  withIcon: PropTypes.bool,
  subsection: PropTypes.string,
  withTextLink: PropTypes.bool,
};
